import React, { useState } from "react";
import { HiCheck } from "react-icons/hi2";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import MainButton, {
  BackButton,
} from "../../components/common/MainButtonComponent";
import Spinner2 from "../../components/Spinner2";
import ExamFlowConfirmModal from "./ExamFlowConfirmModal";
import "./AssessShared.css";
import "./ExamSection.css";

export default function ExamConsentPage({
  exam,
  mode,
  loading,
  errorMessage,
  onBack,
  onProceed,
}) {
  const [accepted, setAccepted] = useState(false);
  const [isExitConfirmOpen, setIsExitConfirmOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <ContentWrapper>
      <section className="exam-consent-page">
        <div className="exam-consent-header">
          <BackButton
            label=""
            onClick={() => setIsExitConfirmOpen(true)}
            title="Back"
          />

          <div className="exam-consent-title">
            <span className="exam-consent-check">
              <HiCheck aria-hidden="true" />
            </span>
            <h1>Exam Details</h1>
          </div>
        </div>


        {errorMessage && <p className="text-danger">{errorMessage}</p>}

        <form
          className="exam-consent-body"
          onSubmit={(event) => {
            event.preventDefault();
            // history.push(
            //   routes.exm_paper.replace(":id", exam.id).replace(":mode", mode)
            // );
            if (!accepted || loading || !exam) return;
            onProceed();
          }}
        >
          {/* Existing static consent content commented intentionally */}
          {/* 
          <h2>Welcome to Your Online paper!</h2>
          <p>
            Before you begin, please read the following instructions carefully.
          </p>

          <div className="exam-consent-copy">
            <strong>Eligibility and Integrity</strong>
            <ul>
              <li>This paper is intended for registered students only.</li>
              <li>No external assistance or collaboration is permitted.</li>
            </ul>

            <strong>Technical Requirements</strong>
            <ul>
              <li>Use a stable internet connection and a compatible browser.</li>
              <li>Do not refresh or close the browser during the paper.</li>
            </ul>

            <strong>Submission Guidelines</strong>
            <ul>
              <li>Save your answers frequently.</li>
              <li>Review answers before submitting the paper.</li>
            </ul>
          </div>
          */}

          <h2>{exam?.title || exam?.name || "Exam Details"}</h2>

          <div className="exam-consent-copy-wrapper">
            <div
              className={`exam-consent-copy ${!isExpanded ? "collapsed" : ""}`}
              dangerouslySetInnerHTML={{
                __html: exam?.terms_content || "",
              }}
            />
            {exam?.terms_content && exam?.terms_content.length > 300 && (
              <button
                type="button"
                className="exam-consent-expand-btn"
                onClick={() => setIsExpanded((prev) => !prev)}
              >
                {isExpanded ? "Read Less" : "Read Full Instructions"}
              </button>
            )}
          </div>

          <label className="setup-row-toggle exam-consent-toggle">
            <span className={!accepted ? "active" : ""}>No</span>
            <input
              type="checkbox"
              checked={accepted}
              onChange={() => setAccepted((currentValue) => !currentValue)}
            />
            <span className={accepted ? "active" : ""}>Yes</span>
          </label>

          <p className="exam-consent-toggle__copy">
            I acknowledge that I have read and understood the online exam terms
            and conditions before starting the exam.
          </p>

          <div className="exam-consent-actions">
            <MainButton
              type="submit"
              action="submit"
              icon="submit"
              // label={mode === "resume" ? "Resume Exam" : "Start Exam"}
              // disabled={!accepted}
              label={
                loading
                  ? "Loading Exam..."
                  : mode === "resume"
                  ? "Resume Exam"
                  : "Start Exam"
              }
              disabled={!accepted || loading || !exam}
              className="exam-consent-actions__submit exam-consent-actions__submit--theme"
            />
          </div>
        </form>

        <ExamFlowConfirmModal
          open={isExitConfirmOpen}
          title="Leave exam mode?"
          message="Going back will leave the consent step and return you to the exams list."
          confirmLabel="Leave"
          // onConfirm={() => history.push(routes.exm)}
          onConfirm={() => {
            setIsExitConfirmOpen(false);
            onBack();
          }}
          onClose={() => setIsExitConfirmOpen(false)}
        />
      </section>
    </ContentWrapper>
  );
}